
import moment from 'moment'
import util,{_} from '@/libs/util'
import common from '@/libs/common.mixin'
import MyPopupPicker from 'c%/PopupPicker'
import signupSuccess from './signup-success.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'


const emptyObject = {
bid: 0,
name: '',
first_tel: '',
sex: ['男'],
birth_time: '',
first_family_rel: ['自己'],
first_family_name: '',
school_id: '',
school_class: '',
input_from: 1,
school_grade: 0
}

export default{
mixins: [common],
components: {
Group,
XInput,
XButton,
Datetime,
PopupPicker,
signupSuccess,
MyPopupPicker,
},
data () {
return {
info: util.copy(emptyObject),
sexList: [['男','女']],
relList: [['自己','爸爸','妈妈','其他']],
show: true,
grades: [],
schools: [],
branchs: []
}
},
computed: {
maxYear () {
return parseInt(moment(new Date()).format('YYYY'))
},
logo () {
let ui = window.CLIENT_PARAMS,
result = '/static/img/student/logo-2.jpg'
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.logo!=''){
result = ui.mobile.logo
}
return result
},
query_bid () {
return this.$route.query.bid || 0
}
},
mounted () {
this.init_grades()
this.init_school()
this.init_branch()
},
methods: {
select_school (school_id) {
this.info.school_id = school_id
},
init_grades () {
this.$rest('open/dicts/?name=grade').get()
.success(data=>{
let grades = data.grade
if(grades.length>0){
this.grades = []

grades.forEach(g=>{
this.grades.push({
key: parseInt(g.name),
value: g.title
})
})
}
})
},
init_school () {
this.$rest('open/global?name=public_schools').get()
.success(data=>{
if(data.length>0){
this.schools = []
data.forEach(s=>{
this.schools.push({
key: s.ps_id,
value: s.school_name
})
})
}
})
},
init_branch () {
this.$rest('open/global?name=branchs').get()
.success(data=>{
if(data.length>0){
this.branchs = []
data.forEach(s=>{
this.branchs.push({
key: s.bid,
value: s.branch_name
})
})
}
})
},
check () {
let info = this.info,
content = '',
result = true
if(this.query_bid) {
this.info.bid = this.query_bid
}
if(!/^1[345789]{1}\d{9}$/.test(info.first_tel)){
content = '手机号格式错误'
result = false
}
if(/^\s*$/.test(info.first_tel)){
content = '请输入学员手机号'
result = false
}
if(/^\s*$/.test(info.name)){
content = '请输入学员姓名'
result = false
}
if(info.bid == 0){
content = '请选择所属校区'
result = false
}
if(content!=''){
this.alert('提示',content)
}

return result
},
deal_param () {
let info = this.info,
params = util.copy(info)
params.sex = this.sexList[0].indexOf(info.sex[0]) + 1
params.first_family_rel = this.relList[0].indexOf(info.first_family_rel[0]) + 1
return params
},
ok () {

if(this.check()) {
let params = this.deal_param()
this.show = false
this.$rest('open/customer').post(params)
.success(data=>{
this.$refs['success'].showSuccess()
}).error(response=>{
this.alert(response.body.message||'提交失败','error')
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/signup.vue